import { useApi } from '~/common/context';
import {
  OverridableQuery,
  restrictApi,
  useQuery,
  UseQueryOptions,
} from '@wyz/utils';
import { ConnectQueryKeys } from '~/connect/api';
import { IErrorApiResponse, ISuccessApiResponse } from '@wyz/types';
import { ISegment } from '~/common/types';

type Options = {
  list?: OverridableQuery<
    UseQueryOptions<ISuccessApiResponse<ISegment[]>, IErrorApiResponse>
  >;
};

export const useManageSegments = <
  TRequestedKeys extends keyof Options,
  TRequestedOptions extends Options = Pick<Options, TRequestedKeys>,
>(
  options: TRequestedOptions,
) => {
  const { callCoreApi } = useApi();

  const listQuery = useQuery({
    queryKey: ConnectQueryKeys.segments.base(),
    queryFn: () =>
      callCoreApi<ISuccessApiResponse<ISegment[]>>('/settings/api/segments'),
    ...options.list,
  });

  return restrictApi(options, { list: listQuery });
};
